import { ReactNode, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

interface ICollapsiblePanelProps {
  header?: string;
  children: ReactNode;
  isPanelOpen?: boolean;
}

export const CollapsiblePanel: React.FC<ICollapsiblePanelProps> = ({ header, children, isPanelOpen }) => {
  const [isOpen, setIsOpen] = useState(isPanelOpen);

  return (
    <div className="w-full bg-[#1a1a3e] shadow-lg rounded-2xl border border-gray-200 overflow-hidden transition-all duration-300">
      <button
        className="w-full flex justify-between items-center p-4 bg-[#292950] text-[#b0e0e6] rounded-t-2xl"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-xl font-semibold">{header}</h3>
        {isOpen ? <FaChevronUp size={24} /> : <FaChevronDown size={24} />}
      </button>
      <div
        className={`transition-max-height duration-300 ease-in-out ${isOpen ? "max-h-screen p-4" : "max-h-0 p-0"}`}
      >
        {isOpen && <div className="text-[#b0e0e6]">{children}</div>}
      </div>
    </div>
  );
};
